// Thin fetch wrapper around the admin subscription endpoints on
// artist-connect-api. Curried with a `firebase` instance (see adminApi.js).

import { request } from './adminApi';

/**
 * Override a user's subscription tier for testing. Writes the subscription as
 * the server ('connects') — clients can't write /subscriptions directly — so
 * the tier styling (Creator/Pro/Business) can be exercised without a real IAP.
 *
 * @param {object} firebase
 * @returns {(input: { userId: string, tier: 'free'|'creator'|'pro'|'business' }) => Promise<{ ok: boolean, tier: string }>}
 */
export const setTierOverride = (firebase) => async ({ userId, tier }) => {
  return request(firebase, '/admin/subscriptions/override', {
    method: 'POST',
    body: JSON.stringify({
      user_id: userId,
      tier,
    }),
  });
};
